import { ITlfActionSetCreateVariantPatchWindow, TlfContextProps } from "./interface";

/**
 * Stores whether the TLF-owned create-patch window is open.
 *
 * @param state - Current TLF context state
 * @param action - Create-window visibility action
 * @returns Updated TLF context state
 */
export const tlf_setCreateVariantPatchWindow = (
  state: TlfContextProps,
  action: ITlfActionSetCreateVariantPatchWindow,
): TlfContextProps => ({ ...state, showCreateVariantPatchWindow: action.show });
